<template>
  <div>
    <section class="blog-area4">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <div class="blog-content-wrap">
                        <div class="blog-item">
                            <div class="blog-img-box">
                                <img  v-if="article.picsrc" :src="`${global.remoteIp}/uploads/${article.picsrc}`" :alt="article.title">
                                <!-- <span class="blog__date">{{article.addtime}}</span> -->
                            </div>
                            <div class="blog-content">
                                <h3 class="blog__title">{{article.title}}</h3>
                                <ul class="blog__list">
                                    <li><span class="la la-user"></span><a href="#">{{article.writer}}</a></li>
                                    <li><span class="la la-tags"></span>
                                        {{article.addtime}}
                                    </li>
                                    <li><span class="la la-eye"></span>{{article.artvisits}}</li>
                                </ul>
                                <p class="blog__desc"  v-html="article.contentHtml" ref="print">
                                </p>
                                <div class="tags-item">
                                    <ul class="tag__list" >
                                        <li><span>新闻来源：</span></li>
                                        <li v-if="article.source"><a :href="article.source">{{article.source}}</a></li>
                                    </ul>
                                    <ul class="social__links">
                                        <li @click="print()"><i class="el-icon-printer"></i><span>打印</span></li>
                                    </ul>
                                </div><!-- end tags-item -->
                            </div><!-- end blog-content -->
                        </div><!-- end blog-post-item -->
                    </div><!-- end blog-post-wrapper -->
                </div><!-- end col-md-12-->
            </div><!-- end row -->
        </div><!-- end container -->
    </section>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
         global,
      article: {},
    };
  },

  components: {},

  computed: {},

  mounted() {
    let plateId = this.$route.params.plateId;

    let articleId = this.$route.params.articleId;
    if(articleId == "000000")
    {
      this.$axios.get(`/api/categorys/${plateId}/articles`).then((res) => {
        if (res.data) {
          let  articles = res.data.data;
          if(articles.length==0) return;
          this.$axios.get(`/api/articles/${articles[0]._id}`).then((res) => {
            if (res.data) {
              this.article = res.data.data;
              if(!this.article.addtime)
              {
                let addtime = this.article.createdAt;
                let date = new Date(addtime);
                this.article.addtime=`${date.getFullYear()}-${("00"+(date.getMonth()+1)).slice(-2)}-${("00"+date.getDate()).slice(-2)} ${("00"+date.getHours()).slice(-2)}:${("00"+date.getMinutes()).slice(-2)}:${("00"+date.getSeconds()).slice(-2)}`
              }
            }
          });
        }
      });
    }else
    {
      this.$axios.get(`/api/articles/${articleId}`).then((res) => {
        if (res.data) {
          this.article = res.data.data;
          if(!this.article.addtime)
          {
            let addtime = this.article.createdAt;
            let date = new Date(addtime);
            this.article.addtime=`${date.getFullYear()}-${("00"+(date.getMonth()+1)).slice(-2)}-${("00"+date.getDate()).slice(-2)} ${("00"+date.getHours()).slice(-2)}:${("00"+date.getMinutes()).slice(-2)}:${("00"+date.getSeconds()).slice(-2)}`
          }
        }
      });
    }
  },

  methods: {
       print(){
        this.$print(this.$refs.print)
    }
  }
}

</script>
<style scoped>
</style>